import { PickemDetails, PickemDetailsBase } from "../PickemDetails";
import { RankemPointsRules } from "./PointsRules";

export type RankemDetails = PickemDetailsBase & {
  additionalRosterIds: string[] | undefined;
  pointsRules: RankemPointsRules;
  subSegmentNum: number | undefined;
};

export const isRankemDetails = (
  pickemDetails: PickemDetails
): pickemDetails is RankemDetails => {
  return pickemDetails.pickemType === "Rankem";
};
